module.exports = __webpack_public_path__ + "img/SleepImproveScheme.b34ea674.jpg";